import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/components/AuthProvider";
import { User, LogOut, ShoppingCart, BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { KitchenInventory } from "./KitchenInventory";
import { ShoppingList } from "./ShoppingList";
import { SavedRecipes } from "./SavedRecipes";

export const Header = () => {
  const { signOut, session } = useAuth();
  const navigate = useNavigate();
  const [isInventoryOpen, setIsInventoryOpen] = useState(false);
  const [isShoppingListOpen, setIsShoppingListOpen] = useState(false);
  const [isSavedRecipesOpen, setIsSavedRecipesOpen] = useState(false);

  const handleLogout = async () => {
    await signOut();
    navigate("/auth");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <h1 className="text-xl font-semibold">😺 Kitty</h1>
        <div className="flex items-center gap-4">
          <Button 
            variant="outline" 
            size="default"
            onClick={() => setIsInventoryOpen(true)}
          >
            View Kitty
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon">
                <User className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem >
                <span>{session?.user.email}</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setIsSavedRecipesOpen(true)}>
                <BookOpen className="mr-2 h-4 w-4" />
                <span>Saved Recipes</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setIsShoppingListOpen(true)}>
                <ShoppingCart className="mr-2 h-4 w-4" />
                <span>Shopping List</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleLogout}>
                <LogOut className="mr-2 h-4 w-4" />
                <span>Log out</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <KitchenInventory open={isInventoryOpen} onOpenChange={setIsInventoryOpen} />
      <ShoppingList open={isShoppingListOpen} onOpenChange={setIsShoppingListOpen} />
      <SavedRecipes open={isSavedRecipesOpen} onOpenChange={setIsSavedRecipesOpen} />
    </header>
  );
};